import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PROFILE_UI_TRANSLATIONS_KEY } from "../constants";
var pt = /*#__PURE__*/_defineProperty({}, PROFILE_UI_TRANSLATIONS_KEY, {
  PROFILE_ACCOUNT: 'Conta',
  PROFILE_COMPANY: 'Compañía',
  PROFILE_NIGHTSWITCH: 'Modo Noturno',
  PROFILE_PANEL: 'Painel',
  PROFILE_LOGOUT: 'Fechar sessão',
  PROFILE_PROFESSOR: 'Professor',
  PROFILE_MENTOR: 'Mentor',
  PROFILE_ADMIN: 'Administrador',
  PROFILE_LEADER: 'Líder',
  PROFILE_SUPERVISOR: 'Supervisor',
  PROFILE_MEMBER: 'Colaborador',
  PROFILE_COURSES: 'Meus cursos',
  PROFILE_PROFILE: 'Meu perfil',
  PROFILE_MANAGE_ACCOUNT: 'Configurar conta',
  PROFILE_HELP_CENTER: 'Centro de ajuda',
  PROFILE_CONFIGURATION: 'Configuração',
  PROFILE_MENTORS: 'Mentores',
  SWITCHER_SUPPLANTED: 'Suplantando:',
  SWITCHER_EXIT: 'Sair da representação',
  SWITCHER_EXIT_MY_ACCOUNT: 'Minha conta',
  SWITCHER_EXIT_ERROR: 'A ação não pode ser executada. Por favor, tente novamente mais tarde.',
  SWITCHER_EXIT_SUCCESS: 'Você saiu da representação com sucesso, espere um momento.',
  // Company Selector
  COMPANY_LABEL: 'COMPANHIA',
  COMPANY_PLACEHOLDER: 'Selecione uma companhia',
  COMPANY_SEARCH_PLACEHOLDER: 'Buscar',
  COMPANY_NO_RESULTS_TITLE: 'Nenhuma companhia encontrada',
  COMPANY_NO_RESULTS_SUBTITLE: 'Tente ajustar seus critérios de busca',
  COMPANY_CORPORATE: 'Corporativo',
  COMPANY_SUBSIDIARY: 'Empresa Subsidiária'
});
export default pt;